module.exports = __webpack_public_path__ + "img/solution--falls-prevention.38014ffa.jpg";